import { useEffect, useState } from "react";
import { motion } from "framer-motion";

import styles from '../styles';
import { staggerContainer } from '../utils/motion';
import { ExploreCard, TitleText, TypingText } from "../components";

import {  Anemo, Electro, Geo, Cryo, Pyro } from '../constants'

import TabComponent from '../components/TabComponent'

import tabs from '../constants/tabs'
import { useStateContext } from "../contexts/ContextProvider";

const Explore = () => {

  const [active, setActive] = useState(2);

  const { indexTab } = useStateContext();

  const [team, setTeam] = useState(Electro);

  useEffect(() => {
    if (indexTab === 'Anemo') {
      setTeam(Anemo);
    } else if (indexTab === 'Electro') {
      setTeam(Electro);
    } else if (indexTab === 'Geo') {
      setTeam(Geo);
    } else if (indexTab === 'Cryo') {
      setTeam(Cryo);
    } else if (indexTab === 'Pyro') {
      setTeam(Pyro);
    }
  }, [indexTab]);

  const tabContentStyle = 'mt-[50px] flex lg:flex-row flex-col min-h-[70vh] gap-5'

  return (
    <section className={`${styles.paddings}`} id='explore'>
      <motion.div
        variants={staggerContainer}
        initial='hidden'
        whileInView='show'
        viewport={{ once: false, amount: 0.25 }}
        className={`${styles.innerWidth} mx-auto flex flex-col`}
      >
        <TypingText title='| Exploration' textStyles='text-center'/>
        <TitleText title={<>Choose your team <br className="md:block hidden" /> to explore </>} textStyles='text-center' />

        {/* Tab menu */}
        <TabComponent />

        {/* Tab content */}
        { 
          tabs.map((tab, index) => (
            <div key={tab.id} className={indexTab === tab.id ? tabContentStyle : 'hidden'}>
              {
                team.map((world, index) => (
                  <ExploreCard
                    key={world.id}
                    {...world}
                    index={index}
                    active={active}
                    handleClick={setActive}
                  />
                ))
              }
            </div>
          )) 
        }
            
      </motion.div>
    </section>
  )
};

export default Explore;
